import { render, staticRenderFns } from "./MyBirthMonthDialog.vue?vue&type=template&id=4df1c9cc"
import script from "./MyBirthMonthDialog.vue?vue&type=script&lang=js"
export * from "./MyBirthMonthDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports